export const optionLables = ["A", "B", "C", "D", "E"];
